export const removeParagraph = (str = '') =>
  str.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '')

export const nl2br = (str: string) => {
  return str.replace(/(\r\n|\n\r|\r|\n)/g, '<br />')
}
